<template>
  <account-infos-form
    :initial-company-name="loggedInUserAccount.companyName"
    :image-url="companyImage"
    :submit-label="t('onboarding.launchMooncamp')"
    @image-cropped="uploadImage"
    @submit="update"
  />
</template>

<script setup>
import AccountInfosForm from '@/components/onboarding/AccountInfosForm.vue';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import useOverlaySpinner from '@/composables/overlay-spinner';
import useSnackBar from '@/composables/snackbar';
import { computed } from 'vue';
import { logCatch } from '@/lib/logger/logger';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['done']);

const { t } = useI18n();
const snackbar = useSnackBar();
const { showOverlaySpinner, hideOverlaySpinner } = useOverlaySpinner();
const accountSvc = useLoggedInUserAccount();
const { loggedInUserAccount } = accountSvc;

const companyImage = computed(() => loggedInUserAccount.value.companyImage?.getURL ?? '');

const update = ({ companyName, companySize }) => {
  showOverlaySpinner(t('moduleSelectionInfos.creatingYourAccount'));
  return accountSvc.updateAccountInfos({ companyName, companySize }).then(() => {
    emit('done');
  }).catch(logCatch(() => {
    snackbar.error();
  })).finally(() => {
    hideOverlaySpinner();
  });
};

const uploadImage = (blob) => accountSvc.uploadImage(blob)
  .catch(logCatch(() => {
    snackbar.error();
  }));
</script>
